import styled from 'styled-components';

import { MAX_WIDTH } from '../../../constants';

export const FieldBlockWrapper = styled.div`
  width: 100%;
  max-width: ${MAX_WIDTH};
`;

export const FieldBlockTitle = styled.div`
  ${(p) => p.theme.typography.subHeader2}
  margin-bottom: 8px;
`;

export const FieldBlockDescription = styled.div`
  ${(p) => p.theme.typography.description}
  margin-bottom: 8px;
  color: ${(p) => p.theme.colors.muted};
`;

interface InputWrapperProps {
  isTopMargin: boolean;
  contentMargin?: string;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  margin-top: ${(props) => (props.isTopMargin ? props.contentMargin || '32px' : '0px')};
`;
